import { reflect } from '@effector/reflect'

import { modalOpener } from '@/shared/ui/modal'

import * as model from './model'
import { AccountReloginDialog as View } from './view'

export const AccountReloginDialog = {
    View: reflect({
        view: View,
        bind: {
            onSwitchAccountButtonClick: model.switchAccountButtonClicked,
            interactionDisabled: model.$interactionDisabled,
        },
    }),
    model,
}

model.showFx.use(modalOpener(AccountReloginDialog.View))
